const workflowsList = {
    namespaced: true,
    state: {
        search: null,
        tableOptions:
        {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "name" ],
            sortDesc : [ false ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
        workFlowDocTypes: [
            { id: 'Avrora.Objects.Modules.Docflow.DocflowObjects.OutgoingDocument', name: 'Исходящие'},
            { id: 'Avrora.Objects.Modules.Docflow.DocflowObjects.IncomingDocument', name: 'Входящие'},
            { id: 'Avrora.Objects.Modules.Docflow.DocflowObjects.InnerDocument', name: 'Внутренние'}
        ]
    },
    mutations: {
        SET_TABLE_SEARCH (state, payload) {
            state.search = payload;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        }
    },
    getters: {
        getTableSearch: (s) => s.search,
        getTableOptions: (s) => s.tableOptions,
        getWorkFlowDocTypes: (s) => s.workFlowDocTypes
    }
}

export default workflowsList;